export const CHART_INFO_TYPES = {
    EVALUATIONS_STATUS: 'evaluations_status',
    QUESTIONNAIRES_RESULTS: 'questionnaires_results',
    EVALUATIONS_STATUS_BY_TEAM: 'evaluations_status_by_team',
    SUBJECTS_RESULTS_BY_NETWORK: 'subjects_results_by_network',
}

export const CHART_FORMATS = {
    BAR: 'bar',
    TABLE: 'table',
    RADAR: 'radar',
    COLUMN: 'column',
}
